import styled from "styled-components"

export const MagentaSection = styled.div`
  text-align: center !important;
  background-color: #e20074;
  color: #fff;
`
